<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/fondo5.jpg"
  style="background-image: url('assets/img/fondo5.jpg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white mt-100">
          <h3 style="color: white">
            EL CENTRO DEL CUSCO
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="welcome-section pt-80 pt-pd-60 pt-40" style="background-image: url('/assets/img/fondo-tomo11.png'); background-size: cover;
background-position: center;">
  <div class="container">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-8 m-auto text-center">
        <div class="section-title-wrap">
          <h2>“EL CENTRO DEL CUSCO”, Morada de historia y cultura viva. </h2>
          <p class="mb-0" style="font-weight: 300;">A continuación, se muestra el Texto cuya intención es transportar a los lectores de la mano
            por la ciudad, contando y mostrando su patrimonio cultural material e inmaterial más significativos, aquellos que se delinearon a lo
            largo de los años, que cuentan historias del pasado y del presente, que hacen así mismo, vivir el presente y reconociendo el pasado.
            Texto que busca introducir a quienes lo lean, en un espacio geográfico cultural, que siempre vibró y vivió intensamente cada etapa de su historia,
            y que fue marcada por su gente en las plazas, calles y edificios en la memoria colectiva.
          </p>
        </div>
      </div><!-- End Section title -->
    </div>
  </div>
</section>

<div class="page-wrapper"
  style="background-image: url('/assets/img/fondo-leyenda-catalogacion.png'); background-size: cover; background-position: center;">
  <div class="accordion-content-wrapper mt-80 mt-md-80 mt-sm-50 mb-80 mb-md-80 mb-sm-50">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <iframe style="width:100%;height:700px" src="https://online.anyflip.com/rhspq/azeg/index.html"  seamless="seamless" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true" ></iframe>
        </div>
      </div>
    </div>
  </div>
</div>
